
export function calcTransportCosts(id) {
	var lpobj = window.datastore.lps.get(id)
	var userCars = lpobj.get('userCars')
 	var alreadyConsideredCars = [];
	var costsCars = 0;
	var costsFuel = 0;
	var costsPt = 0;
	var costsLiving = 0
	var costsLivingRentBuy = 0;
	var costsLivingRunning = 0;
	var kmCar = 0;
	var totaltime = 0;
	// Iterate all daily trips
	if (lpobj.get('dailyTrips') && typeof lpobj.get('dailyTrips') !== 'undefined'  ) {
		var dts = lpobj.get('dailyTrips')
		for (var i=0; i < dts.models.length; i++) {
	 		var dt = dts.models[i]
	 		var mode = dt.get('selectedMode')
	 		if (mode === "car") {
	 			var carId = dt.get('id_car')
	 			var userCar = userCars.get(carId)
	 			kmCar = kmCar + (dt.get('transportModes').CAR.distance * 2 * dt.get('freq') * 4)
	 			totaltime = totaltime + (dt.get('transportModes').CAR.duration * 2 * dt.get('freq') * 4)
	 			
	 			// Calculate costs for fuel
	 			var costsFuelforRoute = userCar.get('consumption_costs_per_m') * dt.get('transportModes').CAR.distance * 2 * dt.get('freq') * 4
	 			costsFuel = costsFuel + costsFuelforRoute
	 			if (alreadyConsideredCars.indexOf(carId) === -1) {
	 				// Static monthly costs for this car have not been added
	 				alreadyConsideredCars.push(carId)
	 				var costsCar = userCar.get('costs_month')
	 				costsCars = costsCars + costsCar
	 			}
	 			
	 		} else if (mode === "public") {
	 			costsPt = dt.get('costs_pt') + costsPt
	 			totaltime = totaltime + (dt.get('transportModes').PUBLIC.duration * 2 * dt.get('freq') * 4)
	 		}
	 		else if (mode === "bike") {
	 			totaltime = totaltime + (dt.get('transportModes').BIKE.duration * 2 * dt.get('freq') * 4)
	 		}
	 		else if (mode === "foot") {
	 			totaltime = totaltime + (dt.get('transportModes').FOOT.duration * 2 * dt.get('freq') * 4)
	 		}
	 	}
	}
	costsLivingRunning = lpobj.get('livingcosts').get('costsRunning')
	if (lpobj.get('livingcosts').get('selectedType') === "rent") {
		costsLiving = lpobj.get('livingcosts').get('costsRent') + lpobj.get('livingcosts').get('costsRunning')
		costsLivingRentBuy = lpobj.get('livingcosts').get('costsRent')
	} else if (lpobj.get('livingcosts').get('selectedType') === "buy") {
		costsLiving = lpobj.get('livingcosts').get('costsLoan') + lpobj.get('livingcosts').get('costsRunning')
		costsLivingRentBuy = lpobj.get('livingcosts').get('costsLoan')
	}
	
	var costsForDriving = parseInt(costsCars + costsFuel)
	var costsPt = parseInt(costsPt)
	
	kmCar = Math.round(kmCar/1000 * 10) / 10
	totaltime = Math.round(totaltime/60 * 10) / 10
	
	var preFinalNumbers = [costsForDriving, costsPt, costsLiving, costsLivingRentBuy, costsLivingRunning, kmCar, totaltime]
	var finalNumbers = []
	for (var i = 0; i < preFinalNumbers.length; i++) {
		finalNumbers[i] = parseFloat(preFinalNumbers[i])
	}
	
 	return finalNumbers
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/dailytrips/calc_costs.js